module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade custom-modal auth-modal",
    attrs: {
      "id": "signup-modal",
      "role": "dialog",
      "aria-labelledby": "signup-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signupUser($event)
      }
    }
  }, [(!_vm.showNextStep) ? [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.name),
      expression: "rules.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "name": "name",
      "placeholder": "Ezi Guy"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('name')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.phone),
      expression: "rules.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "name": "phone",
      "placeholder": "0542010203"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('phone')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill small-margin-top",
    attrs: {
      "type": "button",
      "disabled": !_vm.allowNext
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToNextStep($event)
      }
    }
  }, [_vm._v("Next")])])] : [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.password),
      expression: "rules.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('password')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.password_confirmation),
      expression: "rules.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password_confirmation",
      "name": "password_confirmation",
      "data-vv-as": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.user.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password_confirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('password_confirmation')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill small-margin-top",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToPreviousStep($event)
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-fill small-margin-top",
    attrs: {
      "type": "submit",
      "disabled": !_vm.allowSignup
    }
  }, [_vm._v("Sign Up")])])], _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Already have an account? "), _c('a', {
    staticClass: "text-warning pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.initLogin($event)
      }
    }
  }, [_vm._v("Login")])])], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logowithname.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Hurry! Your food awaits!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-747bb8bf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Signup.vue
// module id = 213
// module chunks = 14